module.exports = __webpack_public_path__ + "img/BAU Seniors_13.efe31fbb.jpg";